var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.drugDataLoading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.drugDataLoading
            ? [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-4" },
                    [
                      _vm.drug
                        ? _c("DrugGeneralInfo", {
                            ref: "generalInfo",
                            attrs: {
                              smallValidDates: true,
                              drug: _vm.drug,
                              combineInvoices:
                                _vm.combineInvoices?.[_vm.drug.id],
                              invoices: _vm.invoices,
                              allStoreDrugsData: _vm.allStoreDrugsData,
                              profitCalculation: _vm.profitCalculation,
                              ordersStat: _vm.ordersStat,
                              storeDrugData: _vm.storeDrugData,
                              soldData: _vm.soldData,
                              freezeInvoices: _vm.freezeInvoices[_vm.drug.id],
                              inModal: true,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col col-md-4" },
                    [
                      _c("DrugSoldStatistics", {
                        attrs: {
                          drug: _vm.drug,
                          invoices: _vm.invoices,
                          ordersStat: _vm.ordersStat,
                          soldData: _vm.soldData,
                          inModal: true,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col col-md-4" },
                    [
                      _c("SmallPriceBlock", {
                        attrs: {
                          drug: _vm.drug,
                          invoices: _vm.invoices,
                          profitCalculation: _vm.profitCalculation,
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group text-left" }, [
                        _c(
                          "label",
                          { staticClass: "text-muted", attrs: { for: "" } },
                          [_vm._v("Наименование на английском")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.drug.en_title,
                              expression: "drug.en_title",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            placeholder: "Наименование на английском",
                          },
                          domProps: { value: _vm.drug.en_title },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.drug,
                                "en_title",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mb-3 text-left card p-2" },
                        [
                          _c("label", { staticClass: "text-muted" }, [
                            _vm._v("Название препарата для страны/поставщика"),
                          ]),
                          _vm._v(" "),
                          _c("TitleForSuppliers", {
                            ref: "suppliersTitles",
                            attrs: { records: _vm.drug.details },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.drug.infoPrices && _vm.drug.infoPrices.lenght
                        ? _c("SalesPricesInfo", { attrs: { drug: _vm.drug } })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-2 text-left" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("p", [_vm._v("Комментарий к закупке")]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.drug.purchase_comment,
                                expression: "drug.purchase_comment",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", rows: "2" },
                            domProps: { value: _vm.drug.purchase_comment },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.drug,
                                  "purchase_comment",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("p", [_vm._v("Коэфициент закупки у поставщиков")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.drugDetails.suppliers_data.order_rate
                                    .value,
                                expression:
                                  "drugDetails.suppliers_data.order_rate.value",
                              },
                            ],
                            class: {
                              "form-control": true,
                              bg_success:
                                _vm.drugDetails.suppliers_data.order_rate
                                  .value &&
                                _vm.drugDetails.suppliers_data.order_rate
                                  .value !== 0,
                            },
                            attrs: {
                              placeholder: "Коэфициент 2,5,10....",
                              type: "text",
                            },
                            domProps: {
                              value:
                                _vm.drugDetails.suppliers_data.order_rate.value,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.drugDetails.suppliers_data.order_rate,
                                  "value",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("p", [_vm._v("Фасовка закупки блистеров")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.drugDetails.suppliers_data
                                    .oposit_order_rate.value,
                                expression:
                                  "drugDetails.suppliers_data.oposit_order_rate.value",
                              },
                            ],
                            class: {
                              "form-control": true,
                              bg_success:
                                _vm.drugDetails.suppliers_data.oposit_order_rate
                                  .value &&
                                _vm.drugDetails.suppliers_data.oposit_order_rate
                                  .value !== 0,
                            },
                            attrs: {
                              placeholder: "Коэфициент 2,5,10....",
                              type: "text",
                            },
                            domProps: {
                              value:
                                _vm.drugDetails.suppliers_data.oposit_order_rate
                                  .value,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.drugDetails.suppliers_data
                                    .oposit_order_rate,
                                  "value",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    !_vm.drugDataLoading && _vm.drug
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _vm.drug.combined_type === 1
                ? [
                    _c("div", { staticClass: "input-group w-25 mb-1" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.drugRequestQty,
                            expression: "drugRequestQty",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number" },
                        domProps: { value: _vm.drugRequestQty },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.drugRequestQty = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.drug.combined_drugs, function (cd) {
                      return _c(
                        "div",
                        [
                          _c("h4", { staticClass: "text-left" }, [
                            _vm._v("Заказ компонента: "),
                            _c("strong", [_vm._v(_vm._s(cd.drug.title))]),
                            _vm._v(
                              " (" +
                                _vm._s(cd.drug.id) +
                                " x " +
                                _vm._s(cd.rate) +
                                ")"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("DrugOrderBlock", {
                            ref: `combined_order_${cd.drug.id}`,
                            refInFor: true,
                            attrs: {
                              requiredQty:
                                Math.floor(_vm.drugRequestQty ?? 0) * cd.rate,
                              drug: cd.drug,
                            },
                          }),
                        ],
                        1
                      )
                    }),
                  ]
                : [
                    _vm.showOrderComponent
                      ? _c("CreatedDrugOrder", {
                          ref: "drugOrder",
                          attrs: {
                            countrySelected: _vm.countrySelected,
                            updateOrderDrug: (invoices, drug = null) =>
                              _vm.updateOrderedInvoices(
                                drug.id,
                                invoices,
                                drug
                              ),
                            requiredQty: _vm.getRequiredQty(),
                            drug: _vm.drug,
                            drugDetails: _vm.drugDetails,
                            costPrice:
                              _vm.invoices &&
                              Math.round(
                                ((_vm.invoices[0] &&
                                  _vm.invoices[0].cost_price) ||
                                  0) * 100
                              ) / 100,
                            closeModal: _vm.closeModal,
                          },
                        })
                      : _vm._e(),
                  ],
            ],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "span",
        { staticClass: "input-group-text", attrs: { id: "basic-addon2" } },
        [_c("strong", [_vm._v("Заказ на количество:")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }